import { render, staticRenderFns } from "./WidgetAiWizard.vue?vue&type=template&id=f2a7618e&scoped=true"
import script from "./WidgetAiWizard.vue?vue&type=script&lang=js"
export * from "./WidgetAiWizard.vue?vue&type=script&lang=js"
import style0 from "./WidgetAiWizard.vue?vue&type=style&index=0&id=f2a7618e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2a7618e",
  null
  
)

export default component.exports